import React from "react";
import AdminNavbarLinks from "../../Navbars/AdminNavbarLinks";

import logoUVerify from "assets/img/Uverify.png";
import { Header, Logo } from "./styles";
import { Box } from "@mui/material";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import { useSideBar } from "hooks/useSidebar";
import { Menu } from "@mui/icons-material";

const HeaderUverify = () => {
  const { collapsed, toggled, rtl, setCollapsed, setToggled } = useSideBar();

  const [logoUV] = React.useState(logoUVerify);

  return (
    <Header>
      <Logo image={logoUV} />
      <Box
        sx={{
          display: { xs: "none", sm: "block" }, // Esconde para `xs`, visível para `sm` ou maior
        }}
      >
        <AdminNavbarLinks rtlActive={rtl} />
      </Box>
      <Box
        sx={{
          display: { xs: "block", md: "none" }, // Visível em xs, sm, e md, escondido para lg e maior
        }}
      >
        <ButtonTS
          // className={classes.appResponsive}
          color="transparent"
          justIcon
          aria-label="open drawer"
          onClick={() => {
            setToggled(!toggled);
            collapsed && setCollapsed(!collapsed);
          }}
        >
          <Menu />
        </ButtonTS>
      </Box>
    </Header>
  );
};

export default HeaderUverify;
